export default {"src":"/trader-new/_next/static/media/refer.3c57b848.svg","height":620,"width":636,"blurWidth":0,"blurHeight":0};